import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { formatDate } from 'lib/helpers/dateUtils';
import { calculateAge, cn, iaRa } from 'lib/helpers/utility';

import InfoItem from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/InfoItem';
import { invoicePreviewKeys } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/lib/constants';
import { getAddressDisplay } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/lib/helpers';
import Dot from 'components/shared/Dot/Dot';

const PatientInformation = ({ patient, created_at, dueDate, invoiceId, hiddenFields = [] }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const itemSize = isMobile ? 'xs' : 'small';

  const hiddenFieldsArray = iaRa(hiddenFields);
  const isAllFieldsHidden = invoicePreviewKeys.every((key) =>
    hiddenFieldsArray.includes(key.value)
  );

  if (isAllFieldsHidden) return null;

  return (
    <div className="flex min-h-fit px-6 py-3 sm:px-2">
      <div className="flex flex-1 flex-col">
        {!hiddenFieldsArray.includes?.('pt_name') && (
          <>
            <InfoItem size={itemSize} value="BILLED TO" color="neutral-500" />
            <InfoItem value={patient?.fullName} />
          </>
        )}
        <div className="flex flex-row flex-wrap items-center gap-1">
          {!hiddenFieldsArray.includes?.('pt_id') && (
            <>
              <InfoItem size={itemSize} value={`#${patient?.id}`} color="neutral-700" />
              <Dot size="xs" color="neutral" />
            </>
          )}
          {patient?.dob &&
            (!hiddenFieldsArray.includes?.('pt_dob') ||
              !hiddenFieldsArray.includes?.('pt_age')) && (
              <>
                {!hiddenFieldsArray.includes?.('pt_dob') && (
                  <InfoItem size={itemSize} value={formatDate(patient?.dob)} color="neutral-700" />
                )}
                {!hiddenFieldsArray.includes?.('pt_age') && (
                  <InfoItem
                    size={itemSize}
                    value={`(${calculateAge({ dateOfBirth: patient?.dob })} years)`}
                    color="neutral-700"
                  />
                )}
              </>
            )}
          {!hiddenFieldsArray.includes?.('pt_gender') && (
            <>
              <Dot size="xs" color="neutral" />
              <InfoItem size={itemSize} value={patient?.gender} color="neutral-700" />
            </>
          )}
        </div>
        {!hiddenFieldsArray.includes?.('pt_address') && (
          <InfoItem size={itemSize} value={getAddressDisplay(patient?.userAddress)} />
        )}
        {!hiddenFieldsArray.includes?.('pt_phone') && (
          <InfoItem size={itemSize} value={patient?.phone} color="neutral-700" />
        )}
        {!hiddenFieldsArray.includes?.('pt_email') && (
          <InfoItem size={itemSize} value={patient?.email} color="neutral-700" />
        )}
      </div>
      <div className="flex flex-col items-end gap-3">
        <div className={cn('flex flex-col items-end', !invoiceId && 'opacity-0')}>
          <InfoItem size={itemSize} value="INVOICE #" color="neutral-500" />
          <InfoItem size={itemSize} value={invoiceId} color="neutral-700" />
        </div>
        {!hiddenFieldsArray.includes?.('date_of_service') && (
          <div className={cn('flex flex-col items-end', !created_at && 'opacity-0')}>
            <InfoItem size={itemSize} value="INVOICE DATE" color="neutral-500" />
            <InfoItem
              size={itemSize}
              value={formatDate(created_at, null, 'MM/dd/yyyy')}
              color="neutral-700"
            />
          </div>
        )}
        {!hiddenFieldsArray.includes?.('due_date') && (
          <div className={cn('flex flex-col items-end', !dueDate && 'opacity-0')}>
            <InfoItem size={itemSize} value="DUE DATE" color="neutral-500" />
            <InfoItem
              size={itemSize}
              value={formatDate(dueDate, 'MM/dd/yyyy')}
              color="neutral-700"
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PatientInformation;
